import { Box } from '@mui/material';

import {
  getFeaturedItemRoute,
  getFeaturedItemSlug,
  getFeaturedItemTitle,
} from 'utils/featuredItems.utils';
import { replacePathParams } from 'utils/routes.utils';
import { aspectRatio } from 'utils/styles.utils';

import { FeaturedItemFragment } from 'types/api/dato-operations.types';

import DatoImage from 'components/@common/DatoImage';
import LinkUnstyled from 'components/@common/LinkUnstyled';

interface Props {
  featuredItem: FeaturedItemFragment;
  priority?: boolean;
  onClick?: () => void;
}

const FeaturedCard = ({ featuredItem, priority = false, onClick }: Props) => {
  const slug = getFeaturedItemSlug(featuredItem);
  const title = getFeaturedItemTitle(featuredItem);
  const route = getFeaturedItemRoute(featuredItem);
  const { coverImage } = featuredItem;

  // Build the href using the appropriate route and slug
  const href = route && slug ? replacePathParams(route, { slug }) : '#';

  return (
    <Box
      component={LinkUnstyled}
      href={href}
      onClick={onClick}
      sx={[
        {
          flex: 1,
          p: 1,
          position: 'relative',
          overflow: 'hidden',
          borderRadius: 4,
        },
        (theme) => ({
          ...aspectRatio(9, 16),
          transition: [theme.transitions.create('opacity')],
          '&:hover': {
            opacity: 0.8,
          },
        }),
      ]}
      aria-label={title}
    >
      <DatoImage
        data={coverImage}
        fill
        priority={priority}
        style={{ objectFit: 'cover' }}
        sizes="512px"
      />
    </Box>
  );
};

export default FeaturedCard;
